/*
    Autogenerated class model from django KeyWord
    -- 2023-03-13 18:02:20.827536
*/
import Vue from 'vue';

// BaseObjectClass defines methods load, save, delete
import { BaseObjectClass, BaseCollection, BaseStoreCollection } from '@/base_object_class';

class KeyWordClass extends BaseObjectClass {
    constructor(rawData = {}) {
        super();
        this.populate(rawData);
    }

    populate(rawData = {}) {
        Vue.set(this, 'isLoading', false);
        Vue.set(this, 'pk', rawData.pk || null);
        Vue.set(this, 'id', rawData.pk || null);
        Vue.set(this, 'createdAt', new Date(rawData.createdAt));
        Vue.set(this, 'updatedAt', new Date(rawData.updatedAt));

        /* Define default values here if needed */
        Vue.set(this, 'order', rawData.order);
        Vue.set(this, 'name', rawData.name);
        Vue.set(this, 'category', rawData.category);
    }

    getBaseUrl() {
        return '/listepro/key-word/';
    }

    get isValid() {
        return true;
    }
}

class KeyWordCollection extends BaseCollection {
    initModel(rawData) {
        return new KeyWordClass(rawData);
    }

    getBaseUrl() {
        return '/listepro/key-word/';
    }
}

class KeyWordStoreCollection extends BaseStoreCollection {
    initModel(rawData) {
        return new KeyWordClass(rawData);
    }

    getBaseUrl() {
        return '/listepro/key-word/';
    }

    getStorePath() {
        return 'listepro/keyWordCollection';
    }
}

export {
    KeyWordClass,
    KeyWordCollection,
    KeyWordStoreCollection,
};
